import merchantListStore from "../store/merchantListStore";
import userStore from "../store/userStore";

export const getCurrentMerchant = () => {
  let currentMerchant = null;
  const groupCode = userStore.getState().userAssociatedCustomerGroups;

  if (groupCode?.length > 1) {
    currentMerchant = merchantListStore.getState().selectedMerchant?.value;
  } else {
    currentMerchant = groupCode?.[0];
  }

  return currentMerchant;
};
